<script setup lang="ts">

import {computed, onMounted, ref, watchEffect} from "vue";

const props = defineProps<{
  modelValue: string | null;
  width?: number;
  height?: number;
  disabled?: boolean;
}>();
const emit = defineEmits<{
  (event: 'update:modelValue', value: string | null): void;
}>();

const canvas = ref<HTMLCanvasElement | null>(null);

let ctx: CanvasRenderingContext2D | null = null;

const width = computed(() => props.width || 400);

const height = computed(() => props.height || 300);

let isDrawing = false;

function startDrawing(x: number, y: number) {
  if (props.disabled)
    return;
  isDrawing = true;
  ctx?.beginPath();
  ctx?.moveTo(x, y);
}

function draw(x: number, y: number) {
  if (!isDrawing)
    return;
  ctx?.lineTo(x, y);
  ctx?.stroke();
}

function stopDrawing() {
  if (!isDrawing)
    return;
  isDrawing = false;
  emit('update:modelValue', canvas.value?.toDataURL() ?? null);
}

watchEffect(() => {
  if (!props.modelValue) {
    ctx?.clearRect(0, 0, width.value, height.value);
    return;
  }
  const image = new Image(width.value, height.value);
  image.src = props.modelValue;
  image.onload = () => ctx?.drawImage(image, 0, 0);
})

onMounted(() => {
  ctx = canvas.value!.getContext("2d");
});

</script>

<template>
  <canvas class="nf-canvas"
          ref="canvas"
          style="touch-action: none"
          :width="width"
          :height="height"
          @pointerdown.prevent="startDrawing($event.offsetX, $event.offsetY)"
          @pointermove.prevent="draw($event.offsetX, $event.offsetY)"
          @pointerup.prevent="stopDrawing"
  ></canvas>
</template>
